let ProcedureDetailController = function ($filter, $mdDialog, $scope, $state, Procedure, Toast) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.procedure;

  activate();

  function activate() {
    loadResource($ctrl.id);
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';

      Procedure.show(id)
        .then(response => {
          setPlaceHolderValues(response);
          $ctrl.procedure = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function setPlaceHolderValues(obj) {
  	_.forEach(obj, (value, key) => {
  		if (value === null || value === undefined) {
  			obj[key] = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

ProcedureDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Procedure', 'Toast'];

export default ProcedureDetailController;


// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure-detail.controller.js